<template>
  <page-container>
    <h3>Welcome to Guides</h3>
    <p>Under construction :(</p>
    <small>If you are willing to become an <strong>author</strong> of guides, please contact us at <email subject="Hello PO: How to become a Guide Author"></email></small>
  </page-container>
</template>

<script>

export default {
}
</script>
